import { useRef } from 'react';
import Page from '@renter-hub/components/RenterPage';
import HeroSection from './sections/HeroSection';
import WhatArePayments from './sections/WhatArePayments';
import WhyPayOnline from './sections/WhyPayOnline';
import HowSignUp from './sections/HowSignUp';
import HowPaymentsWork from './sections/HowPaymentsWork';
import IsItSecure from './sections/IsItSecure';
import CostToPay from './sections/CostToPay';
import CommonQuestions from './sections/CommonQuestions';
import HelmetContainer from '@common/components/HelmetContainer';
import SeoConstants from '@renter-hub/constants/seoConstants';

interface LandingPageProps {
  enableContinueToOnboarding: boolean;
  featureFlagEnableRentReporting: boolean;
  paymentReportingOptedIn: boolean | null;
  continueToOnboarding: (
    onboardingStatus: string,
    featureFlagEnableRentReporting: boolean,
    paymentReportingOptedIn: boolean | null,
  ) => void;
  onboardingStatus: string;
  goToSignInPage: () => void;
  authenticated: boolean;
}

const LandingPage = (props: LandingPageProps) => {
  const {
    enableContinueToOnboarding,
    authenticated,
    onboardingStatus,
    featureFlagEnableRentReporting,
    paymentReportingOptedIn,
  } = props;

  const howSignUpRef = useRef<HTMLDivElement>(null);
  const costToPayRef = useRef<HTMLDivElement>(null);

  const continueToOnboarding = () => {
    props.continueToOnboarding(onboardingStatus, featureFlagEnableRentReporting, paymentReportingOptedIn);
  };

  const scrollToHowSignUp = () => {
    if (howSignUpRef.current && typeof howSignUpRef.current.scrollIntoView === 'function') {
      howSignUpRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToCostToPay = () => {
    if (costToPayRef.current && typeof costToPayRef.current.scrollIntoView === 'function') {
      costToPayRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const goToSignInPage = () => {
    props.goToSignInPage();
  };

  return (
    <Page customCss={{ marginTop: '-32px !important' }}>
      <Page.MainSection fullWidth>
        <HelmetContainer {...SeoConstants.landingPage} />
        <HeroSection
          onClick={enableContinueToOnboarding ? continueToOnboarding : scrollToHowSignUp}
          enableContinueToOnboarding={enableContinueToOnboarding}
          authenticated={authenticated}
          goToSignInPage={goToSignInPage}
        />
        <WhatArePayments />
        <WhyPayOnline />
        {!enableContinueToOnboarding && (
          <div ref={howSignUpRef}>
            <HowSignUp />
          </div>
        )}
        <HowPaymentsWork scrollToCostToPay={scrollToCostToPay} />
        <IsItSecure />
        {!enableContinueToOnboarding && <HowSignUp bold />}
        <div ref={costToPayRef}>
          <CostToPay />
        </div>
        <CommonQuestions />
      </Page.MainSection>
    </Page>
  );
};

export default LandingPage;
